import type { AppNotification } from '../services/api';
import { inferWorkoutNotificationKind } from './notificationDisplay';

/** Coalesce activity/record cards while preserving the raw feed for read actions. */
export function coalesceWorkoutNotifications(groups: Record<string, AppNotification[]>): Record<string, AppNotification[]> {
  const selected = new Map<number, AppNotification>();
  const kind = (item: AppNotification) => inferWorkoutNotificationKind(item.description, item.workout_kind);
  const workoutId = (item: AppNotification): number | null => {
    if (item.notifiable_type?.split('\\').pop() !== 'Workout') return null;
    if (!['workout_completed', 'workout_record_broken'].includes(kind(item) ?? '')) return null;
    const id = Number((item.notifiable as Record<string, unknown> | undefined)?.id);
    return Number.isFinite(id) && id > 0 ? id : null;
  };
  for (const item of Object.values(groups).flat()) {
    const id = workoutId(item);
    if (id == null) continue;
    const previous = selected.get(id);
    const priority = (value: AppNotification) => kind(value) === 'workout_record_broken' ? 1 : 0;
    if (!previous || priority(item) > priority(previous) || (priority(item) === priority(previous) && item.id > previous.id)) selected.set(id, item);
  }
  return Object.fromEntries(Object.entries(groups).map(([date, items]) => [date, items.filter(item => {
    const id = workoutId(item);
    return id == null || selected.get(id) === item;
  })] as const).filter(([, items]) => items.length > 0));
}
